export default __webpack_public_path__ + "logo.3f9207fc24a528ef5b28b8fab846a0d9.png";